import React, { useState } from 'react'
import { Link } from 'react-router-dom';
import SmallScreenNav from './SmallScreenNav';

const Navigation = () => {
    const [isCategoryOpen, setCategoryOpen] = useState(false);
    const handleCatagorySelect = () => {
        setCategoryOpen(false);
    };

    return (
        <>
            <div id="navigation" className="navigation-main-block-first">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-3 col-md-5">
                            <div className="dropdown category-dropdown">
                                <button
                                    className="btn btn-secondary dropdown-toggle"
                                    type="button"
                                    onClick={() => setCategoryOpen(!isCategoryOpen)}
                                >
                                    <i className="flaticon-hamburger" /> All Categories {" "}
                                    <i className="flaticon-down-arrow" />
                                </button>
                                {isCategoryOpen && (
                                    <ul className="dropdown-menu show">
                                        <li><Link className="dropdown-item" to="#" onClick={handleCatagorySelect}>Smartphones</Link></li>
                                        <li><Link className="dropdown-item" to="#" onClick={handleCatagorySelect}>Tablets</Link></li>
                                        <li><Link className="dropdown-item" to="#" onClick={handleCatagorySelect}>Smartwatches</Link></li>
                                        <li><Link className="dropdown-item" to="#" onClick={handleCatagorySelect}>Fitness trackers</Link></li>
                                        <li><Link className="dropdown-item" to="#" onClick={handleCatagorySelect}>Headphones</Link></li>
                                        <li><Link className="dropdown-item" to="#" onClick={handleCatagorySelect}>Speakers</Link></li>
                                        <li><Link className="dropdown-item" to="#" onClick={handleCatagorySelect}>Gaming consoles</Link></li>
                                        <li><Link className="dropdown-item" to="#" onClick={handleCatagorySelect}>Portable chargers</Link></li>
                                        <li><Link className="dropdown-item" to="#" onClick={handleCatagorySelect}>Bluetooth earphones</Link></li>
                                    </ul>
                                )}
                            </div>
                        </div>
                        <div className="col-lg-7 col-md-3">
                            <nav className="navbar navbar-expand-lg bg-body-tertiary">
                                <div className="navbar-collapse" id="navbarNavAltMarkup">
                                    <ul className="navbar-nav">
                                        <li className="nav-item dropdown">
                                            <Link
                                                className="nav-link dropdown-toggle active"
                                                to="#"
                                                role="button"
                                                data-bs-toggle="dropdown"
                                                aria-expanded="false"
                                                aria-current="page"
                                            >
                                                Home <i className="flaticon-down-arrow" />
                                            </Link>
                                            <ul className="dropdown-menu">
                                                <li>
                                                    <Link className="dropdown-item active" to="/">
                                                        Home Page 01
                                                    </Link>
                                                </li>
                                                <li>
                                                    <Link className="dropdown-item" to="/Hometwo">
                                                        Home Page 02
                                                    </Link>
                                                </li>
                                                <li>
                                                    <Link className="dropdown-item" to="/HomeThree">
                                                        Home Page 03
                                                    </Link>
                                                </li>
                                                <li>
                                                    <Link className="dropdown-item" to="/Homefour">
                                                        Home Page 04
                                                    </Link>
                                                </li>
                                                <li>
                                                    <Link className="dropdown-item" to="/Homefive">
                                                        Home Page 05
                                                    </Link>
                                                </li>
                                                <li>
                                                    <Link className="dropdown-item" to="/HomeSix">
                                                        Home Page 06
                                                    </Link>
                                                </li>
                                                <li>
                                                    <Link className="dropdown-item" to="/Homeseven">
                                                        Home Page 07
                                                    </Link>
                                                </li>
                                            </ul>
                                        </li>
                                        <li className="nav-item dropdown">
                                            <Link
                                                className="nav-link dropdown-toggle"
                                                to="#"
                                                role="button"
                                                data-bs-toggle="dropdown"
                                                aria-expanded="false"
                                            >
                                                Shop <i className="flaticon-down-arrow" />
                                            </Link>
                                            <ul className="dropdown-menu">
                                                <li>
                                                    <Link className="dropdown-item" to="/Shop">
                                                        Shop
                                                    </Link>
                                                </li>
                                                <li>
                                                    <Link className="dropdown-item" to="/Shop-filter">
                                                        Sidebar Shop 01
                                                    </Link>
                                                </li>
                                                <li>
                                                    <Link className="dropdown-item" to="/Shop-filter2">
                                                        Sidebar Shop 02
                                                    </Link>
                                                </li>
                                                <li>
                                                    <Link className="dropdown-item" to="/Shopdetails">
                                                        Shop Details
                                                    </Link>
                                                </li>
                                            </ul>
                                        </li>
                                        <li className="nav-item">
                                            <Link className="nav-link" to="/Shop" title="">
                                                Smartwatches
                                            </Link>
                                        </li>
                                        <li className="nav-item">
                                            <Link className="nav-link" to="/Shop" title="" >
                                                Laptops & Computers
                                            </Link>
                                        </li>
                                        <li className="nav-item dropdown">
                                            <Link
                                                className="nav-link dropdown-toggle"
                                                to="#"
                                                role="button"
                                                data-bs-toggle="dropdown"
                                                aria-expanded="false"
                                            >
                                                Blog <i className="flaticon-down-arrow" />
                                            </Link>
                                            <ul className="dropdown-menu">
                                                <li>
                                                    <Link className="dropdown-item" to="/Blog">
                                                        Blog
                                                    </Link>
                                                </li>
                                                <li>
                                                    <Link className="dropdown-item" to="/Blogdetails">
                                                        Blog Details
                                                    </Link>
                                                </li>
                                            </ul>
                                        </li>
                                        <li className="nav-item dropdown">
                                            <Link
                                                className="nav-link dropdown-toggle"
                                                to="#"
                                                role="button"
                                                data-bs-toggle="dropdown"
                                                aria-expanded="false"

                                            >
                                                Pages <i className="flaticon-down-arrow" />
                                            </Link>
                                            <ul className="dropdown-menu">
                                                <li >
                                                    <Link className="dropdown-item" to="/Aboutus">
                                                        About Us
                                                    </Link>
                                                </li>
                                                <li>
                                                    <Link className="dropdown-item" to="/Affiliate">
                                                        Affiliate
                                                    </Link>
                                                </li>
                                                <li>
                                                    <Link className="dropdown-item" to="/Career" >
                                                        Career
                                                    </Link>
                                                </li>
                                                <li>
                                                    <Link className="dropdown-item" to="/Faq" >
                                                        Faq
                                                    </Link>
                                                </li>
                                                <li>
                                                    <Link className="dropdown-item" to="/Error" >
                                                        404
                                                    </Link>
                                                </li>
                                                <li>
                                                    <Link className="dropdown-item" to="/Contactus" >
                                                        Contact Us
                                                    </Link>
                                                </li>
                                            </ul>
                                        </li>
                                    </ul>
                                </div>
                            </nav>
                        </div>
                        <div className="col-lg-2 col-md-4">
                            <div className="navigation-discount-block">
                                <Link to="#" title="">
                                    <i className="flaticon-discount" />
                                    Best Discounts
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <SmallScreenNav />
        </>
    )
}

export default Navigation
